import Vue from 'vue'
import Vuetify, {
  VTextField,
  VSnackbar,
  VBtn,
  VIcon,
  VAvatar
} from 'vuetify/lib'
import VuetifyConfirm from 'vuetify-confirm'
import VuetifyToast from 'vuetify-toast-snackbar'

// TODO: load only required icons
import '@fortawesome/fontawesome-free/css/all.css'

const ICONS = {
  // shoppingCart: 'fas fa-shopping-cart',
  // store: 'fas fa-store',
  receipt: 'fas fa-receipt',
  wallet: 'fas fa-wallet',
  tag: 'fas fa-tag',
  utensils: 'fas fa-utensils',
  clock: 'fas fa-clock',
  cog: 'fas fa-cog',
  lifeRing: 'fas fa-life-ring',
  signOut: 'fas fa-sign-out-alt',
  random: 'fas fa-random',
  hamburger: 'fas fa-hamburger',
  frown: 'far fa-frown',
  heart: 'far fa-heart',
  globe: 'fas fa-globe',
  leaf: 'fas fa-leaf',
  flask: 'fas fa-flask',
  chicken: 'fas fa-drumstick-bite',
  heartFull: 'fas fa-heart',
  flag: 'fas fa-flag',
  trash: 'fas fa-trash-alt',
  pen: 'fas fa-pen',
  redo: 'fas fa-redo-alt',
  compass: 'fas fa-compass',
  calendar: 'fas fa-calendar',
  arrowBack: 'fas fa-arrow-left',
  share: 'fas fa-share-alt',
  menu: 'fas fa-bars',
  add: 'fas fa-plus',
  remove: 'fas fa-minus',
  store: 'fas fa-store',
  camera: 'fas fa-camera',
  sun: 'fas fa-sun',
  clipboardCheck: 'fas fa-clipboard-check',
  clipboardList: 'fas fa-clipboard-list',
  lock: 'fas fa-lock',
  pauseCircle: 'fas fa-pause-circle',
  caretDown: 'fas fa-caret-down'
}

const options = {
  icons: {
    iconfont: 'fa',
    values: ICONS
  },
  theme: {
    themes: {
      light: {
        primary: '#00A69C',
        secondary: '#78909C',
        accent: '#FF4060'
      }
    }
  },
  components: {
    VTextField,
    VSnackbar,
    VBtn,
    VIcon,
    VAvatar
  }
}

// Vue Material Design component framework
Vue.use(Vuetify, options)

const vuetify = new Vuetify(options)

// Extension for Vuetify confirm dialog
Vue.use(VuetifyConfirm, {
  vuetify,
  buttonTrueText: 'OK',
  buttonFalseText: 'Cancel',
  width: 350
})

// Basic Vue toast service that uses Vuetify Snackbar component
Vue.use(VuetifyToast, {
  x: undefined,
  color: undefined,
  showClose: false
})

export default vuetify
